import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **D-Edge <3 Availpro**
 *
 * @exports bs_26
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const dataLayer = window.dataLayer;
    const isBookingEngine = window.location.hostname.match(/secure-hotel-booking.com$/);
    // Force page_check to some users
    const shouldForciblyPageCheck = [1037942, 1044848, 1033582, 1033409, 1045798, 1045740, 1033545, 1033582].includes(thn.data.accountUserId) || thn.data.propertyId === 1025920;
    let refreshPage = null;
    let debouncedPageCheck = null;
    let desktopPriceRefresh = null;
    let desktopCurrencyRefresh = null;
    let desktopRoomsRefresh = null;
    let mobilePriceRefresh = null;
    engine._isMobile = function isMobile() {
        return isBookingEngine && window.location.pathname.substr(0, 7).match(/touch/);
    };
    engine._isBe = function isBe() {
        // Check if we're in a BE which uses the newer version of the dataLayer
        return isBookingEngine && window.dataLayer && !!thn.objectGet(window.dataLayer, 'bookingStep', { first: false });
    };
    /**
       * @memberOf module:bs_0
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const userLoggedSelector = document.querySelector('.menu-customer-top span');
        const isLogged = !!(userLoggedSelector && thn.isVisible(userLoggedSelector) && userLoggedSelector.textContent.includes('@'));
        return isLogged;
    };
    engine._isRoomFilter = function isRoomFilter() {
        const allowedRoomFilters = {
            // Hôtel Mansart
            1011813: [22053],
            // Hôtel d'Orsay
            1011814: [19699],
            // Hotel de la Tamise
            1011815: [61166],
            // Hotel Brighton
            1012757: [28338],
            // Hôtel de la Place du Louvre
            1012758: [12480],
            // Hotel Parc Saint Severin
            1012761: [16963],
            // Hôtel des Saints Pères
            1012759: [23626],
            // Hotel Aiglon
            1012762: [291],
        };
        let roomFilter = window.bookingEngine && window.bookingEngine.params && window.bookingEngine.params.roomId;
        // Store room id to preserve the room filter
        thn.data.roomId = roomFilter || 0;
        if (!roomFilter && document.querySelector('.room-filters, .fa-filter')) {
            // Check if there's some filter filter active
            // On Desktop we look at checkboxes
            // On mobile se need to check if the button to see the filters text has a number'
            if ([...document.querySelectorAll('.room-filters input[type=checkbox]')].filter((checkbox) => checkbox.checked).length
                || thn.parseNumber(document.querySelector('.fa-filter')?.nextElementSibling?.textContent)) {
                roomFilter = true;
            }
        }
        // remove the room filter when it is allowed
        if (allowedRoomFilters[thn.data.propertyId]?.includes(roomFilter)) {
            roomFilter = false;
        }
        return roomFilter;
    };
    engine._defaultDomParams = function () {
        const adultSearch = document.querySelector('[data-bind="text: guests.selectedAdultCount"]')?.textContent;
        const childrenSearch = document.querySelector('[data-bind="text: guests.selectedChildCount"]')?.textContent;
        const infantSearch = document.querySelector('[data-bind="text: guests.selectedInfantCount"]')?.textContent;
        const generalSearchParams = document.querySelector('.digest__guest-details')?.textContent.split(',') || [];
        return {
            adults: thn.parseNumber(adultSearch || generalSearchParams[0] || '0'),
            children: thn.parseNumber(childrenSearch || generalSearchParams[1] || '0'),
            infants: thn.parseNumber(infantSearch || generalSearchParams[2] || '0'),
        };
    };
    /**
     * @memberOf module:bs_26
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
    engine.boot = function boot() {
        let referralPageName;
        // There cases where we need to override the widgetData.adults and widgetData.children, but in the search URL we should use the real values
        // We declare those variables here to delete them easily on shutdown
        thn.data.searchAdults = 0;
        thn.data.searchChildren = 0;
        thn.data.searchInfants = 0;
        // Store room id to preserve the room filter
        thn.data.roomId = (window.bookingEngine && window.bookingEngine.params && window.bookingEngine.params.roomId) || 0;
        if (isBookingEngine) {
            // If the dataLayer doesn't exists yet, we should create it as an empty array to detect changes when the GTM creates it (or adds information to it)
            // If the dataLayer doesn't exists and it's d-edge, if we don't create it the wont detect changes correctly if we don't create the dataLayer helper
            if (!window.dataLayer) {
                window.dataLayer = [];
            }
            // Debounce the page check to avoid multiple calls
            debouncedPageCheck = thn.debounce(function () {
                referralPageName = thn.data.pageName;
                thn.pageCheck();
                if (thn.data.pageName === referralPageName && referralPageName === 'Rooms and Rates') {
                    if (shouldForciblyPageCheck) {
                        thn.pageCheck({ force: true });
                        return;
                    }
                    thn.widgets.price.refresh();
                }
                // Golden Tulip Aix Les Bains PID 1028115 & Loges du park PID 1028116
                // The client of these hotels want the PW to work on Reception BE page(hotel page) for their receptionists.
                // URL pathname must contain one of the two.
                if (window.location.pathname.match(/JI7E-15219|JI7E-15220/)) {
                    const debouncedUpdate = thn.debounce(() => thn.widgets.price.update(), 800);
                    debouncedUpdate();
                }
            }, 800);
            thn.bus.on('dataLayer:push', ({ message }) => {
                if (message.event === 'VirtualPageView') {
                    debouncedPageCheck();
                }
            }, true);
            /**  To know in which step of the booking the user is, we need to check the datalayer event "bookingStep"
                          *   The different steps are:
                          *   - Calendar -> 'DateSelection'
                          *   - Rooms and Rates  -> 'RoomSelection'
                          *   - User Register Page -> 'Summary' (Page tracking for Payment/URP is disabled for security reasons)
                          *   - Booking Confirmed -> 'Confirmation'
                          *
                          *    * We need to set some delay until all the animations end
                          */
            // Remove the price widget when the user reaches the 'ExtraSelection' step.
            thn.bus.on('dataLayer:push', ({ message }) => {
                if (message.bookingStep === 'ExtraSelection') {
                    thn.widgets.price.remove();
                }
            }, true);
            thn.pageUnload(() => {
                thn.bus.detach('dataLayer:event.VirtualPageView', debouncedPageCheck);
                thn.bus.detach('dataLayer:bookingStep.ExtraSelection', thn.widgets.price.remove);
            });
        }
        thn.shutdown(function () {
            delete thn.data.searchAdults;
            delete thn.data.searchChildren;
            delete thn.data.searchInfants;
            delete thn.data.roomId;
        });
        // Observe the DOM for changes for Hotel Le Pigonnet refresh the page
        const hotelLePigonnet = thn.data.propertyId === 1015339;
        const container = document.documentElement;
        if (container && hotelLePigonnet && !isBookingEngine) {
            refreshPage = thn.debounce(thn.pageCheck, 400);
            thn.observeDom(container, refreshPage, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(container, refreshPage);
            });
        }
        // Observe the DOM for changes in the language
        const containerLang = document.querySelector('body');
        if (containerLang) {
            let refreshLang = thn.debounce(thn.languageCheck, 400);
            thn.observeDom(containerLang, refreshLang, {
                attributes: true,
                attributeFilter: ['lang'],
            });
            thn.shutdown(() => {
                refreshLang.cancel();
                thn.stopObserveDom(containerLang, refreshLang);
                refreshLang = null;
            });
        }
        // Observe the DOM for changes in the calendar
        const containerCalendar = document.querySelector('#dyncal_wrapper');
        if (containerCalendar) {
            const refreshCalendar = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(containerCalendar, refreshCalendar, {
                attributes: true,
                attributeFilter: ['class'],
            });
            thn.shutdown(() => {
                refreshCalendar.cancel();
                thn.stopObserveDom(containerCalendar, refreshCalendar);
            });
        }
    };
    /**
       * @memberOf module:bs_26
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        // Hôtel D'orsay
        if (thn.data.propertyId === 1011814) {
            setTimeout(thn.pageCheck, 300);
        }
        if (window.location.hostname.match(/alcovehotelnice/)) {
            thn.languageCheck().then(function ({ changed }) {
                if (!changed) {
                    thn.widgets.price.refresh();
                }
            });
        }
    };
    /**
       * @memberOf module:bs_26
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang;
            function getLangFromURL() {
                const langUrl = window.location.pathname.match(/^\/(\w{2}(-\w{2,4})?)(\/|$)/);
                return langUrl ? langUrl[1] : null;
            }
            function getLangFromDataLayer() {
                const langDl = thn.dataLayerHelper.get('context.language');
                return langDl ? langDl.trim(0, 2) : null;
            }
            // GET LANG IN WEBSITE OR BE
            lang = getLangFromURL() || getLangFromDataLayer();
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            // GET LANG ON WEBSITE FOR SPECIFIC CASES (NOT BE)
            // Victoria Garden Hotels
            if ([1036561].includes(thn.data.accountUserId)) {
                lang = document.querySelector('.wpml-ls-current-language span.wpml-ls-native')?.textContent?.toLowerCase();
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                resolve('fr');
                return;
            }
            // PropertyId: Fourviere Hotel, Ermitage College Hotel, Hotel Marignan, Alcove Hotel
            // UserId: Le Patio Bastille, Hôtel du Collectionneur and Les Jardins du Marais, Groupe CIM
            if (([1014297, 1014605, 1014157, 1026574].includes(thn.data.propertyId) || [1042500, 1033100].includes(thn.data.accountUserId))) {
                lang = document.documentElement.lang || document.querySelector('#w-dropdown-toggle-0')?.textContent;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
            }
            // Fesch Hotel
            if ([1051769].includes(thn.data.propertyId)) {
                lang = document.querySelector('.gt-current-lang')?.getAttribute('data-gt-lang');
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
            }
            // Hostellerie La Briqueterie
            if ([1051276].includes(thn.data.propertyId)) {
                lang = document.querySelector('select')?.value;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
            }
            // Fjall Garden Hotel
            if ([1024968].includes(thn.data.propertyId) && window.location.hostname.match(/fjallgarden\.se/)) {
                resolve('sv');
                return;
            }
            // Ioka Hotel
            if ([1029499].includes(thn.data.propertyId)) {
                lang = document.querySelector('#language')?.value;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
            }
            reject('no_language');
        });
    };
    /**
       * Forbid execution on:
       * - availpro widget iframe
       *
       * @memberOf module:bs_26
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation(ctx) {
        let isAllowedLocation = true;
        if (window.location.hostname === 'widgets.secure-hotel-booking.com') {
            isAllowedLocation = false;
        }
        if (thn.data.propertyId === 1014026
            && isBookingEngine
            && thn.widgets.price.getPromocode().promocode === 'PRIVATE') {
            isAllowedLocation = false;
        }
        if ([1015367, 1014023, 1014024, 1014025].includes(thn.data.propertyId) && isBookingEngine && thn.widgets.price.getPromocode().promocode === 'BLACK') {
            isAllowedLocation = false;
        }
        return isAllowedLocation;
    };
    /**
       * @memberOf module:bs_26
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const allowedParams = [
            'arrivalDate',
            'selectedAdultCount',
            'selectedChildCount',
            'selectedInfantCount',
            'nights',
            'roomId',
        ];
        const url = new URL(ctx.baseUrl);
        // example "pre-url": https://www.secure-hotel-booking.com/smart/Saint-Paul-Rive-Gauche/2G41/fr/search?arrivalDate=2018-03-24&selectedAdultCount=2&selectedChildCount=0&selectedInfantCount=0&selectedRate=BOOSTER&nights=1&promoCode=FOO&_ga=2.242014337.263015922.1520508131-745869666.1520508131
        // That URL redirects to the final BE URL: https://www.secure-hotel-booking.com/smart/Saint-Paul-Rive-Gauche/2G41/fr/?_ga=2.242014337.263015922.1520508131-745869666.1520508131
        const validBeUrl = url.hostname.match(/secure-hotel-booking.com/)
            || url.pathname.match(/(smart\/[^/]+\/[^/]+|touch\/[^/]+\/[^/]+(\/[^/]+)?)\/\w{2}(-\w{2,4})?(\/((index|search)\/?)?)?(\/RoomSelection)?$/i);
        if (validBeUrl) {
            // remove dangling slash
            const lastCharIsSlash = url.pathname.substring(url.pathname.length - 1) === '/';
            if (lastCharIsSlash) {
                url.pathname = url.pathname.slice(0, -1);
            }
            // We prepare URL path here
            const pathParts = url.pathname?.split('/') || [];
            // Language is part of the path,
            const langRegex = /^[a-zA-Z]{2}(-[a-zA-Z]{2})?$/;
            const languageIndex = pathParts.findIndex((part) => langRegex.test(part));
            if (languageIndex !== -1) {
                pathParts[languageIndex] = '[language]';
            }
            // Remove RoomSelection from the pathname
            const roomSelectionIndex = pathParts.findIndex((part) => part === 'RoomSelection');
            if (roomSelectionIndex !== -1) {
                pathParts.splice(roomSelectionIndex, 1);
            }
            // Add the search part to the end of the path
            const lastPart = pathParts?.slice(-1)[0];
            if (lastPart !== 'search') {
                pathParts.push('search');
            }
            url.pathname = pathParts.join('/');
            // Redirect to the specific device version
            const hotelsWithSpecialIdFormat = [1026599, 1026601, 1026600]; // Hotels with special ID format (mobile: /2ARI/19552/ and desktop: /2ARI-19552/)
            const isMobile = thn.data.media.name === 'mobile';
            const excludedPartsPattern = /hotel|smart|touch|redirect|language|search|^([a-z]{2}(-[A-Z]{2})?)$/i;
            const hotelId = pathParts.filter((part) => !excludedPartsPattern.test(part) && part !== '');
            // Prepare the path for mobile/desktop
            let updatedPath = pathParts.join('/').replace(isMobile ? '/smart/' : '/touch/', isMobile ? '/touch/' : '/smart/');
            // Adjust ID format if the hotel is in the special format list
            if (hotelsWithSpecialIdFormat.includes(thn.data.propertyId) && hotelId.length > 0) {
                const formattedHotelId = hotelId.length > 1 ? hotelId.join('-') : hotelId[0];
                if (isMobile) {
                    // If it's mobile, format the hotel ID to the mobile version (2ARI/19552)
                    updatedPath = updatedPath.replace(/\/(\w+)-(\d+)\//, '/$1/$2/');
                }
                else {
                    // If it's desktop, format the hotel ID to the desktop version (2ARI-19552)
                    const pathPartsWithoutHotelId = pathParts.filter((part) => !hotelId.includes(part));
                    updatedPath = [
                        ...pathPartsWithoutHotelId.slice(0, 3),
                        formattedHotelId,
                        ...pathPartsWithoutHotelId.slice(3),
                    ].join('/').replace('/touch/', '/smart/');
                }
            }
            url.pathname = updatedPath;
            const propertiesWithSpecificParamsV1 = [1028134]; // Parameters in this property ?AVP_list_days=%2f13&AVP_list_months=2021-12&AVP_list_nights=3&guestCountSelector=ReadOnly&date=2021-12-13&nuits=3&adultes=2&enfants=0&bébé=0#roomselection
            if (propertiesWithSpecificParamsV1.includes(thn.data.propertyId)) {
                const listDays = ctx?.newData?.dateBegin?.slice(-2);
                const listMonths = ctx?.newData?.dateBegin?.slice(0, 7);
                url.searchParams.set('AVP_list_days', listDays);
                url.searchParams.set('AVP_list_months', listMonths);
                // Calculate the number of nights
                let nights = 1;
                if (ctx.newData?.dateBegin && ctx.newData?.dateEnd) {
                    nights = thn.daysBetween(ctx.newData.dateBegin, ctx.newData.dateEnd);
                }
                url.searchParams.set('AVP_list_nights', nights);
                url.searchParams.set('guestCountSelector', 'ReadOnly');
                const dateBegin = ctx?.newData?.dateBegin?.replace(/-/g, '/');
                url.searchParams.set('date', dateBegin);
                url.searchParams.set('nuits', nights);
                url.searchParams.set('adultes', '[adults]');
                url.searchParams.set('enfants', '[children]');
                url.searchParams.delete('bébé');
                // export into ctx.new_url
                ctx.newUrl = url.toString();
                return ctx;
            }
            // This property only needs these parameters
            // https://www.secure-hotel-booking.com/touch/Hotel-La-Perouse-Nice-Baie-des-Anges/2VIH/en-US/RoomSelection?arrivalDate=2023%2F06%2F09&departureDate=2023%2F06%2F10&selectedAdultCount=2&selectedChildCount=0&selectedInfantCount=1&selectedHotelId=9858&promoCode=TEL23
            const applyOnlyToMobileVersion = [1033545].includes(thn.data.accountUserId) && thn.data.media.name === 'mobile';
            const propertiesWithSpecificParamsV2 = [1027348, 1014297, 1048020, 1048304, 1047202, 1047203];
            if (propertiesWithSpecificParamsV2.includes(thn.data.propertyId) || applyOnlyToMobileVersion) {
                url.pathname = url.pathname.match(/\/search|RoomSelection/) ? url.pathname : `${url.pathname}/search`;
                url.searchParams.set('arrivalDate', '[date_begin]');
                url.searchParams.set('departureDate', '[date_end]');
                url.searchParams.set('selectedAdultCount', '[adults]');
                url.searchParams.set('selectedChildCount', '[children]');
                const infantCount = thn.data.searchInfants || '0';
                url.searchParams.set('selectedInfantCount', infantCount);
                // Add selectedHotelId to the URL
                if (thn.data.propertyId === 1027348) {
                    url.searchParams.set('selectedHotelId', '9858');
                }
                ctx.newUrl = url.toString();
                return ctx;
            }
            // Ensure we go directly to the results step
            url.hash = 'roomselection';
            // Remove all not allowed params from query
            Object.keys(url.searchParams).forEach(function (key) {
                if (!allowedParams.includes(key)) {
                    url.searchParams.delete(key);
                }
            });
            // prepare URL for params substitution
            url.searchParams.set('arrivalDate', '[date_begin]');
            url.searchParams.set('selectedAdultCount', '[adults]');
            let nights = 1;
            if (ctx.newData?.dateBegin && ctx.newData?.dateEnd) {
                nights = thn.daysBetween(ctx.newData.dateBegin, ctx.newData.dateEnd);
            }
            url.searchParams.set('nights', nights);
            url.searchParams.set('selectedAdultCount', '[adults]');
            url.searchParams.set('selectedChildCount', '[children]');
            url.searchParams.set('selectedInfantCount', '[infants]');
            // If the room filter is applied, apply the room_id to preserve the filter
            if (thn.data?.roomId) {
                url.searchParams.set('roomId', '[room_id]');
                ctx.newData.room_id = thn.data.roomId;
            }
            // export into ctx.new_url
            ctx.newUrl = url.toString();
            // There cases where we need to override the widgetData.adults and widgetData.children, but in the search URL we should use the real values
            ctx.newData.adults = thn.data?.searchAdults || ctx.data?.adults;
            ctx.newData.children = thn.data?.searchChildren || ctx.data?.children;
            ctx.newData.infants = thn.data?.searchInfants || 0;
            // this BE uses datein/nights instead of dateout
            ctx.newData.nights = nights || 1;
            // then format of dates: yyyy/mm/dd -> yyyy-mm-dd
            ctx.newData.dateBegin = ctx.data.dateBegin && ctx.data.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd && ctx.data.dateEnd.replace(/\//g, '-');
        }
        else {
            // This is not a valid BE URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_26
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        // ------------------------
        // Mobile version
        // ------------------------
        if (engine._isMobile()) {
            const mobileContainer = document.querySelector('.room-selection');
            if (mobileContainer && !mobilePriceRefresh) {
                const loader = mobileContainer?.querySelector('.room-selection__loader');
                mobilePriceRefresh = thn.debounce(() => {
                    if (!thn.isVisible(loader)) {
                        ctx.widget.refresh();
                    }
                }, 600);
                thn.observeDom(mobileContainer, mobilePriceRefresh, {
                    childList: true,
                    subtree: false,
                    characterData: false,
                });
                thn.pageUnload(() => {
                    if (mobilePriceRefresh) {
                        mobilePriceRefresh.cancel();
                        thn.stopObserveDom(mobileContainer, mobilePriceRefresh);
                        mobilePriceRefresh = null;
                    }
                });
            }
            return;
        }
        // ------------------------
        // Desktop version
        // ------------------------
        // observe currency change
        const currencyEl = document.querySelector('.menu-currency-top');
        if (currencyEl && !desktopCurrencyRefresh) {
            desktopCurrencyRefresh = thn.debounce(() => {
                const loader = document.querySelector('.page-loader');
                if (!thn.isVisible(loader)) {
                    ctx.widget.refresh();
                }
            }, 800);
            thn.observeDom(currencyEl, desktopCurrencyRefresh, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
                attributeFilter: ['class', 'style'],
            });
            thn.pageUnload(() => {
                if (desktopCurrencyRefresh) {
                    desktopCurrencyRefresh.cancel();
                    thn.stopObserveDom(currencyEl, desktopCurrencyRefresh);
                    desktopCurrencyRefresh = null;
                }
            });
        }
        // Observe the DOM for changes in the room filters
        const container = document.querySelector('html');
        if (container.length && !desktopPriceRefresh) {
            desktopPriceRefresh = thn.debounce(() => {
                ctx.widget.refresh();
                if (ctx.widget.isSet({ acceptWithoutAvailability: true })) {
                    thn.stopObserveDom(container, desktopPriceRefresh);
                    desktopPriceRefresh = null;
                }
            }, 1200);
            thn.observeDom(container, desktopPriceRefresh, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
                attributeFilter: ['class', 'style'],
            });
            thn.pageUnload(() => {
                if (desktopPriceRefresh) {
                    desktopPriceRefresh.cancel();
                    thn.stopObserveDom(container, desktopPriceRefresh);
                    desktopPriceRefresh = null;
                }
            });
        }
        // Observe the DOM for changes in the room filters
        const roomFilters = document.querySelector('.room-filters');
        if (roomFilters && !desktopRoomsRefresh) {
            desktopRoomsRefresh = thn.debounce(() => {
                ctx.widget.refresh();
            }, 1200);
            thn.observeDom(roomFilters, desktopRoomsRefresh, {
                childList: true,
                subtree: true,
            });
            thn.pageUnload(() => {
                if (desktopRoomsRefresh) {
                    desktopRoomsRefresh.cancel();
                    thn.stopObserveDom(roomFilters, desktopRoomsRefresh);
                    desktopRoomsRefresh = null;
                }
            });
        }
    };
    const getDatesFromDatalayer = () => {
        const dateBeginItem = thn.objectGet(dataLayer, 'checkinDate', { first: false }) || '';
        const dateEndItem = thn.objectGet(dataLayer, 'checkoutDate', { first: false }) || '';
        if (dateBeginItem && dateEndItem) {
            const [dateBegin, dateEnd] = [dateBeginItem.replace(/-/g, '/'), dateEndItem.replace(/-/g, '/')];
            return [dateBegin, dateEnd];
        }
        return '';
    };
    const getDatesFromDom = () => {
        const dateBeginEl = document.querySelector('.check-in-datepicker')?.value;
        const dateEndEl = document.querySelector('.check-out-datepicker')?.value;
        if (dateBeginEl && dateEndEl) {
            const [dateBegin, dateEnd] = [translateDate(dateBeginEl, thn.data.language || 'en'), translateDate(dateEndEl, thn.data.language || 'en')];
            return [dateBegin, dateEnd];
        }
        return '';
    };
    /**
       * @memberOf module:bs_26
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const harveyHotelUid = 1035804;
        const chateauHotelsUid = 1041617;
        const shouldDivideByNights = [1040620, 1035079].includes(thn.data.accountUserId);
        // Some hotels need a different logic for fair comparison, where rooms with higher occupancy than the search parameters are excluded.
        const usersComparingWithSearchParameters = [1040954, 1041318, 1040121, 1041617, 1038297, 1040791, 1036561, 1037942, 1041059, 1037109, 1044379, 1044641, 1040545, 1045798, 1045740, 1033545, 1045198].includes(thn.data.accountUserId);
        // Some users want rates to be avoided when there is an "availability request" option.
        const usersAvoidingAvailabilityRequestRate = [1026572].includes(thn.data.accountUserId);
        // Sometimes we only want the cheapest room, regardless of occupancy.
        const ignoreOccupancy = ![1026600, 1014157, 1024869, 1026533, 1014605].includes(thn.data.propertyId);
        let nights;
        // DATES
        const [dateBegin, dateEnd] = getDatesFromDatalayer() || getDatesFromDom();
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        if (widgetData.dateBegin && widgetData.dateEnd) {
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // GUESTS
        // Helper function to get values from DOM
        const getElementValue = (selector, fallbackValue) => {
            const element = document.querySelector(selector);
            return element?.value ? thn.parseNumber(element.value) : fallbackValue;
        };
        const isActiveSelectionEl = !!document.querySelector('.extra-selection-section');
        const defaultParams = engine._defaultDomParams();
        const adultsDl = dataLayer && thn.parseNumber(thn.objectGet(dataLayer, 'adultCount', { first: false }));
        const childDl = dataLayer && thn.parseNumber(thn.objectGet(dataLayer, 'childCount', { first: false }));
        const adultsDom = getElementValue('#adults', defaultParams.adults);
        const childDom = getElementValue('#children', defaultParams.children);
        widgetData.adults = isActiveSelectionEl ? adultsDl : adultsDom;
        // There cases where we need to override the widgetData.adults and widgetData.children, but in the search URL we should use the real values
        // Store the real number of adults (number of adults the user search)
        thn.data.searchAdults = widgetData.adults;
        widgetData.children = isActiveSelectionEl ? childDl : childDom;
        // Store the real number of children (number of children the user search)
        thn.data.searchChildren = widgetData.children;
        // The updating of the number of infants is buggy
        // widgetData.children += thn.objectGet(dataLayer, 'infantCount', { first: false }) || 0;
        // Store value of infants for adding it up on the generated search url
        const infantsDom = getElementValue('#infants', defaultParams.infants);
        thn.data.searchInfants = infantsDom;
        widgetData.children += thn.data.searchInfants;
        widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
        // ROOM DATA
        /* To obtain the correct price, we need to check if any room matches the search occupancy.
           If no matching room is found, we should return the price of the cheapest room.
           If there’s no cheaper room (with less guest than the search), return 'no-rooms'.
           This check is necessary because some systems show all rooms, not just those that meet the search criteria.
        */
        // Helper function to obtain the price of the room
        const getRoomData = (el, isPackage) => {
            let pricePerStay = thn.parseNumber((el.querySelector('.rate-price .rate-price__price-amount, .room-rates-col-button a, .room-rates-item-total-price') || el.querySelector('.rooms-rates-col-button, .room-rates-final-price'))?.textContent || '');
            const pricePerNight = thn.parseNumber(el.querySelector('.room-rates-item-price-moy'));
            if (nights && ((engine._isMobile() || isPackage || shouldDivideByNights) || pricePerStay)) {
                pricePerStay /= nights;
            }
            return { pricePerStay, pricePerNight };
        };
        // Helper function to obtain the numbers of adults and children of the room, if it's not possible, count the number of icons
        const getOccupancy = (el) => {
            let occupancy = (thn.parseNumber(el.querySelector('.occupancy__adult-count')?.textContent) + thn.parseNumber(el.querySelector('.occupancy__child-count')?.textContent))
                || el.querySelectorAll('.occupancy-icon-adult')?.length || 0;
            // If we could get the occupancy, try obtaining it using  it's parent as an element to obtain the occupancy
            if (!occupancy && el.closest('tbody')) {
                const parent = el.closest('tbody');
                // First try to get the occupancy values form a neighbour
                occupancy = (thn.parseNumber(parent.querySelector('.occupancy__adult-count')?.textContent || '0') + thn.parseNumber(parent.querySelector('.occupancy__child-count')?.textContent || '0'));
                // If not possible, count the occupancy icons
                if (!occupancy && parent.querySelector('.room-rates-item:not(.room-rates-item-package)')) {
                    occupancy = parent.querySelectorAll('.room-rates-item:not(.room-rates-item-package) .occupancy-number').length;
                }
            }
            return occupancy;
        };
        // MAIN LOGIC
        // Obtain room data: occupancy and price (filter 0/null values and only get visible prices and sort it by the cheapest room)
        const isContinental = thn.data.accountUserId === 1032579;
        const roomsInfo = [...document.querySelectorAll('.room-rates-item, .card.room__rate, .room-rates-item-package, .room-rates-wrapper')]
            .filter((el) => thn.isVisible(el))
            .map((el) => {
            // If the price is from a package it will be always as 'total price' so we need to divide it by nights
            const isPackage = !!el.querySelector('.room-rates-col-rate-plan-package, .package-recap, .room-rates-package-content') && !isContinental;
            const isEarlyBooking = /early booking/i.test(el.querySelector('.room-rates-item-title-meal-plan, .rate-recap__header h3')?.textContent);
            const { pricePerStay, pricePerNight } = getRoomData(el, nights);
            const occupancy = getOccupancy(el);
            const hasPromocode = !!el.querySelector('.room-rates-col-rate-promo-code');
            // Check if there is available rooms (rooms without this mark: 'To accommodate all of your guests, you need to add another room type or select additional beds (upon availability)')
            const exceedsOccupancy = el.parentNode?.parentElement?.previousElementSibling?.querySelector('[data-bind*="text: notEnoughPlace"]')
                ? thn.isVisible(el.parentNode.parentElement.previousElementSibling.querySelector('[data-bind*="text: notEnoughPlace"]'))
                : false;
            // Check if the room can be booked online now. if not this bookingAvailableNow will be false because the selector showing the message 'Reply within 48 hours' will be visible
            const bookingAvailableNow = !thn.isVisible(el.querySelector('td.room-rates-col-button-booking-request > p.room-rates-item-request-subtitle.small'));
            // Rate with Availability Request option
            const isAvailabilityRequest = !!el.querySelector('.room-rates-button-booking-request');
            const isRateToAvoid = ((hasPromocode && thn.data.accountUserId === harveyHotelUid) || (exceedsOccupancy && usersComparingWithSearchParameters) || (isAvailabilityRequest && usersAvoidingAvailabilityRequestRate)) ? 1 : 0;
            return {
                occupancy: occupancy,
                price: pricePerStay || pricePerNight,
                special: isPackage || isEarlyBooking,
                rateToAvoid: isRateToAvoid,
                bookingAvailableNow,
            };
        })
            .filter((room) => (room.occupancy || room.price) && !room.rateToAvoid)
            .sort((a, b) => a.price - b.price);
        // Matching rooms and price logic
        // Check if the number of guests matches the occupancy of any room
        const roomsMatchingOccupancy = roomsInfo.filter((room) => room.occupancy === widgetData.guests);
        let price;
        // Check if there is some room filter applied (the BE won't show all the rooms available)
        if (engine._isRoomFilter()) {
            widgetData.priceSpecial = 1;
        }
        if (!thn.empty(roomsInfo) && usersComparingWithSearchParameters) {
            price = thn.data.accountUserId === chateauHotelsUid ? roomsInfo.find((room) => room.bookingAvailableNow && !room.special)?.price : roomsInfo[0].price;
            widgetData.roomsDispo = [{
                    adults: widgetData.adults,
                    children: widgetData.children,
                    childrenAges: Array(widgetData.children).fill().map((_, i) => (i < widgetData.children - thn.data.searchInfants ? 4 : 1)),
                }];
        }
        else if (ignoreOccupancy && !thn.empty(roomsMatchingOccupancy)) {
            price = roomsMatchingOccupancy[0].price;
            if (roomsMatchingOccupancy[0].special || engine._isRoomFilter()) {
                widgetData.priceSpecial = 1;
            }
        }
        else if (!thn.empty(roomsInfo)) {
            // We didn't find any rooms that matches the number of guests. Check if there's some room with less occupancy and return it's room dispo
            price = roomsInfo[0].price;
            if (roomsInfo[0].occupancy > widgetData.guests || roomsInfo[0].special || engine._isRoomFilter()) {
                widgetData.priceSpecial = 1;
            }
            // We need to instruct the scraper to use room data for searching instead of the user's input, as there's no price difference between children and adults (PID: 1025483).
            widgetData.adults = roomsInfo[0].occupancy || 2;
            widgetData.children = 0;
            widgetData.guests = widgetData.adults;
        }
        if (!thn.empty(price) && widgetData.dateBegin && widgetData.dateEnd) {
            // On mobile we only get the price per night
            widgetData.price = price;
            const currency = document.querySelector('.room-rate-item-price-moy, .room-rates-item-price-moy, .rate-price__price-amount, .room-rates-item-total-price, span[data-bind*="formattedTotalPrice"]')?.textContent;
            widgetData.currency = currency?.includes('lei') ? 'RON' : thn.parseCurrency(currency);
            widgetData.set = true;
            // Sometimes, when we force the PW to refresh, no-rooms is not reset to the default value
            widgetData.noRooms = false;
        }
        else if (!document.querySelector('.extra-selection-section')) {
            // Don't flag no-rooms on extras page
            this.logger.warn('---  NO ROOMS AVAILABLE  ---');
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       *
       * @memberOf module:bs_26
       *
       */
    engine._roomDetailsParseData = function roomDetailsParseData() {
        const roomDetailsArray = [];
        const roomSelector = document.querySelectorAll('.template-room');
        if (roomSelector.length) {
            roomSelector.forEach(function (element, idx) {
                const typeRoomSelector = {
                    Suite: 'suite',
                    Classic: 'classic',
                    Deluxe: 'deluxe',
                    Superior: 'superior',
                    Junior: 'junior',
                    Family: 'family',
                    Single: 'single',
                    Twin: 'twin',
                    Double: 'double',
                    'Double (kid)': 'niño',
                    Triple: 'triple',
                };
                const roomName = (element.querySelector('[data-bind="text: name"]') || {}).textContent || '';
                const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
                const roomAdults = element.nextSibling.nextSibling.querySelectorAll('.room-rates-item')[0].querySelectorAll('.occupancy-icon-adult').length || 2;
                const child = element.nextSibling.nextSibling.querySelectorAll('.room-rates-item')[0].querySelectorAll('.occupancy-icon-child').length || 0;
                const priceInfo = element.nextSibling.nextSibling.querySelectorAll('.room-rates-item');
                const roomData = {
                    id: '',
                    name: roomName,
                    adults: roomAdults,
                    children: child,
                    prices: [],
                };
                roomData.type = roomType;
                if (priceInfo.length) {
                    priceInfo.forEach(function (priceUnit) {
                        const refundableBlock = (priceUnit.querySelector('.room-rates-item-info-text') || {}).textContent;
                        const priceItemName = (priceUnit.querySelector('.room-rates-item-title-meal-plan') || {}).textContent;
                        const price = thn.parseNumber((priceUnit.querySelector('span[data-bind="text: formattedTotalPrice"]') || {}).textContent);
                        const priceData = {
                            id: '',
                            name: priceItemName,
                            totalNight: price,
                            breakfast: priceItemName.toLowerCase().includes('breakfast') ? 1 : 0,
                            refundable: refundableBlock.toLowerCase().includes('non refundable') ? 0 : 1,
                        };
                        roomData.prices.push(priceData);
                    });
                    roomDetailsArray.push(roomData);
                }
                return roomData;
            });
        }
        return roomDetailsArray;
    };
    /**
      * @memberOf module:bs_26
      * @this thn.widgets.booking
      * @see {@link Booking#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingDataLayer = window.dataLayer && thn.objectGet(window.dataLayer, 'booking', { first: false });
        const bookingId = bookingDataLayer?.transaction?.id || bookingDataLayer?.booking_reference || document.querySelector('.booking-info__value')?.textContent || thn.parseUrlParameter('bookingReference') || thn.dataLayerHelper.get('booking')?.booking_reference;
        if (!bookingId) {
            return widgetData;
        }
        // DATES
        widgetData.dateBegin = (bookingDataLayer?.checkinDate || thn.dataLayerHelper.get('booking')?.checkinDate)?.replace(/-/g, '/');
        widgetData.dateEnd = (bookingDataLayer?.checkoutDate || thn.dataLayerHelper.get('booking')?.checkoutDate)?.replace(/-/g, '/');
        // Boking ID
        widgetData.bookingId = bookingId;
        // PRICE & CURRENCY
        widgetData.price = bookingDataLayer?.transaction?.total?.totalPrice?.invoiced || bookingDataLayer?.total_price || thn.parseNumber(document.querySelector('.basket__line_type_total .basket__line__price')?.textContent) || thn.dataLayerHelper.get('booking')?.total_price;
        widgetData.currency = bookingDataLayer?.currencies?.invoiced || thn.parseCurrency(document.querySelector('.basket__line_type_total .basket__line__price')?.textContent) || thn.dataLayerHelper.get('booking')?.currencies?.invoiced;
        widgetData.promocode = thn.widgets.price.getPromocode().promocode;
        return widgetData;
    };
    /**
      * @memberOf module:bs_26
      * @this thn.widgets.booking
      * @see {@link Price#get_promocode}
      *
      * @param {object} ctx - The context object.
      */
    engine.getPromocode = function getPromocode(ctx) {
        const datalayerPromocode = window.dataLayer && (thn.dataLayerHelper.get('context.searchParameters.offerCode') || thn.dataLayerHelper.get('offerCode') || thn.dataLayerHelper.get('coupon'));
        // Booking confirm page promocode
        // '.basket-discount' contains something like this text: 'Promocode: BACKTOPARIS'
        const bcPromocode = (((document.querySelector('.basket-discount') || {}).textContent || '').trim().match(/\w{2,}$/) || [])[0];
        const promocode = datalayerPromocode || bcPromocode;
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
